module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('meta', {
    attrs: {
      "content": "text/html; charset=utf-8",
      "http-equiv": "Content-Type"
    }
  }), _c('meta', {
    attrs: {
      "content": "text/html; charset=UTF-8"
    }
  }), _c('title', [_vm._v(" STRANGE FIRE ")]), _c('link', {
    attrs: {
      "href": "default.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "cta",
    attrs: {
      "id": "p0019-01-0"
    }
  }, [_c('a', {
    attrs: {
      "id": "page1"
    }
  }), _c('a', {
    attrs: {
      "href": "#/chapter2#ii4",
      "id": "tt4"
    }
  }, [_vm._v("PART ONE")])]), _vm._v(" "), _c('p', {
    staticClass: "ser1"
  }, [_c('img', {
    staticClass: "maxwidth",
    attrs: {
      "alt": "978140020518_0007_002.jpg",
      "src": "images/978140020518_0007_002.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "ct1",
    attrs: {
      "id": "p0019-02-1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/chapter2#ii4"
    }
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ONFRONTING A")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OUNTERFEIT")]), _vm._v(" R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EVIVAL")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-60530fdd","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chapter4.vue
// module id = 75
// module chunks = 0